import React, { Component } from "react";
import { MDBRow, MDBCol, MDBContainer, MDBCard, MDBCardBody, MDBCardText } from "mdbreact";
import picc1 from "../assets/images/improve_system.jpg";
import scholarship1 from "../assets/2025/k1.jpg";
import scholarship2 from "../assets/2025/k2.jpg";
// import scholarship2 from "../assets/images/scholarship2.jpg";
import scholarship3 from "../assets/2025/k3.jpg";
import scholarship4 from "../assets/2025/k4.jpg";
import MetaTags from "react-meta-tags";

export default class Scholarship extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        return (<>
            <MetaTags>
                <title>ขั้นตอนการกู้ยืมเงินกองทุนเงินให้กู้ยืมเพื่อการศึกษา (กยศ.)</title>
                <meta name="description" content="ขั้นตอนการกู้ยืมเงินกองทุนเงินให้กู้ยืมเพื่อการศึกษา (กยศ.) Kamphaeng Phet Rajabhat University" />
                <meta property="og:title" content="ขั้นตอนการกู้ยืมเงินกองทุนเงินให้กู้ยืมเพื่อการศึกษา (กยศ.)" />
                <meta property="og:image" content="../../public/favicon.ico" />
            </MetaTags>
            <br />
            <MDBContainer fluid >
                <MDBRow>
                    <MDBCol lg="1" md="1" sm="1"></MDBCol>
                    <MDBCol lg="10" md="10" sm="10">
                        <MDBCard>
                            <MDBCardBody>
                                <MDBCardText>
                                    <h4 className="card-header bg-primary text-white" style={{ margin: "0 0 10px 0" }}>ขั้นตอนการกู้ยืมเงินกองทุนเงินให้กู้ยืมเพื่อการศึกษา (กยศ.)</h4>
                                    <div style={{ fontSize: "16px" }}>
                                        {/* ดาวน์โหลดแบบคำขอกู้ยืมเงินได้ที่เว็บไซต์ <a className="btn btn-info" href="https://e-studentloan.kpru.ac.th/" target="_blank">คลิกที่นี่</a> */}
                                        <u className="black-text"><b><i className="fas fa-file-download"></i> ดาวน์โหลดเอกสารและตัวอย่าง </b></u><br />
                                        <li>ดาวน์โหลดเอกสารและตัวอย่างหนังสือให้ความยินยอมเปิดเผยข้อมูล/หนังสือรับรองรายได้ครอบครัว กยศ.102 <a href="https://std.kpru.ac.th/kpnnews/studentloan/file/270525641350.pdf" target="_blank">คลิกที่นี่</a></li>
                                        <li>ตัวอย่างใบแสดงผลการเรียนมัธยมปลาย <a href="https://std.kpru.ac.th/kpnnews/studentloan/file/190425651350.pdf" target="_blank">คลิกที่นี่</a></li>
                                        <li>หนังสือรับรองการแยกกันอยู่ <a href="https://std.kpru.ac.th/th/download/documents/divorce.pdf" target="_blank">คลิกที่นี่</a></li>
                                        <li>หนังสือรับรองการตาย <a href="https://std.kpru.ac.th/th/download/documents/dead.pdf" target="_blank">คลิกที่นี่</a></li>
                                        {/* <li>คู่มือสำหรับสถานศึกษาในการดำเนินงานกองทุนเงินให้กู้ยืมเพื่อการศึกษา ประจำปีการศึกษา 2565 <a href="https://std.kpru.ac.th/kpnnews/studentloan/file/studentloan-kpru-manual-2565.pdf" target="_blank">คลิกที่นี่</a></li> */}
                                        <li>คู่มือสำหรับสถานศึกษาในการดำเนินงานกองทุนเงินให้กู้ยืมเพื่อการศึกษา ประจำปีการศึกษา 2566 <a href="https://mua.kpru.ac.th/imagesbg/studentloan-kpru-manual-2566.pdf" target="_blank">คลิกที่นี่</a></li>
                                    </div>
                                    <MDBRow>
                                        <MDBCol className="text-center" size="12">
                                            <img style={{ maxWidth:'600px',margin: "10px 0 0 0", boxShadow: "1px 1px 2px black, 0 0 25px gray, 0 0 5px darkgray" }} src={scholarship1} width="100%" />
                                        </MDBCol>
                                        <MDBCol className="text-center" size="12">
                                            <img style={{  maxWidth:'600px',margin: "10px 0 0 0", boxShadow: "1px 1px 2px black, 0 0 25px gray, 0 0 5px darkgray" }} src={scholarship2} width="100%" />
                                        </MDBCol>
                                        <MDBCol className="text-center" size="12">
                                            <img style={{ maxWidth:'600px', margin: "10px 0 0 0", boxShadow: "1px 1px 2px black, 0 0 25px gray, 0 0 5px darkgray" }} src={scholarship3} width="100%" />
                                        </MDBCol>
                                        <MDBCol className="text-center" size="12">
                                            <img style={{ maxWidth:'600px', margin: "10px 0 0 0", boxShadow: "1px 1px 2px black, 0 0 25px gray, 0 0 5px darkgray" }} src={scholarship4} width="100%" />
                                        </MDBCol>
                                    </MDBRow>
                                </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                    <MDBCol lg="1" md="1" sm="1"></MDBCol>
                </MDBRow>

            </MDBContainer>
        </>)
    }
}